import VaultConfig from './config'
import { parseJson } from '../../components/utils/storage'

export default {
  getExtractionToken(state) {
    return state.extractionToken
  },
  getVaultMnemonic(state) {
    return state.vaultMnemonic || sessionStorage.getItem('vault.vaultMnemonic') || ''
  },
  getVault(state) {
    return state.vault
  },

  getVaultId(state) {
    return state.vaultId || localStorage.getItem(VaultConfig.LOCAL_STATES.VAULT_ID) || ''
  },

  getVaultWallet(state) {
    return state.vaultWallet
  },

  getVaultPin(state) {
    return state.vaultPin
    // return localStorage.getItem('vaultPin')
  },
  getVaultSalt(state) {
    return state.vaultSalt || localStorage.getItem(VaultConfig.LOCAL_STATES.VAULT_SALT)
  },
  getVaultLockStatus() {
    return localStorage.getItem(VaultConfig.LOCAL_STATES.VAULT_LOCK)
  },
  getVaultData() {
    return localStorage.getItem(VaultConfig.LOCAL_STATES.VAULT_DATA)
  },
  getVaultDataRaw() {
    const vaultDataRawStr = localStorage.getItem(VaultConfig.LOCAL_STATES.VAULT_DATA_RAW)
    return parseJson(vaultDataRawStr)
  },
  getVaultCredentials() {
    const vaultDataRawStr = localStorage.getItem(VaultConfig.LOCAL_STATES.VAULT_DATA_RAW)
    const vaultRaw = parseJson(vaultDataRawStr, {})
    const { hypersign } = vaultRaw
    const { credentials } = hypersign || { credentials: [] }
    return credentials
  },
  getAuthServerAuthToken(state) {
    return state.authServerAuthToken || localStorage.getItem(VaultConfig.LOCAL_STATES.AUTH_SERVER_TOKEN)
  },

  getVaultDataCredentials() {
    const vaultDataRawStr = localStorage.getItem(VaultConfig.LOCAL_STATES.VAULT_DATA_RAW)
    const vaultDataRaw = parseJson(vaultDataRawStr, {})
    const { hypersign } = vaultDataRaw
    const { credentials } = hypersign || { credentials: [] }
    return credentials
  },
  getThirdPartyAuth(state) {
    return state.authenticationAccessToken
  },
  getThridPartyAuth(state) {
    return state.authenticationAccessToken
  },

  getUserDID() {
    // TODO check if user vault is unlocked
    const vaultDataRawStr = localStorage.getItem(VaultConfig.LOCAL_STATES.VAULT_DATA_RAW)
    if (vaultDataRawStr) {
      const vaultDataRaw = parseJson(vaultDataRawStr, {})

      const { hypersign } = vaultDataRaw
      if (hypersign) {
        return hypersign.did
      }
    }
  },

  getCredentialFromVault: (state) => (params) => {
    const raw = localStorage.getItem(VaultConfig.LOCAL_STATES.VAULT_DATA_RAW)
    const vaultDataRaw = parseJson(raw)

    if (!vaultDataRaw) {
      return
    }

    const { hypersign } = vaultDataRaw
    const { credentials } = hypersign || { credentials: [] }
    const { schemaIds } = state

    let credentialToReturn
    Object.keys(schemaIds).forEach((schema) => {
      const { schemaId } = schemaIds[schema]
      const credential = credentials.find((credential) => {
        if (credential) {
          // TODO: We can also add filter for trusted issuer later in the presentation request
          if (credential.credentialSchema?.id === schemaId && params.trustedIssuerList.includes(credential.issuer)) {
            return credential
          }
          if (credential.type.includes(schema) && params.trustedIssuerList.includes(credential.issuer)) {
            return credential
          }
        }
      })

      if ((credential && params.credentialType.includes(schema)) || (credential && params.credentialType.includes(credential.type[1]))) {
        credentialToReturn = credential
      }
    })

    return credentialToReturn
  },
}
